import {Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import { Builder } from '../model/builder';
import { TourApiService } from '../services/tour-api.service';
import { Subscription } from 'rxjs/Rx';
import { ActivatedRoute, Router } from '@angular/router';
import {Community} from '../model/community';
import {Model} from '../model/model';
import {Observable} from 'rxjs/Observable';
import {TourService} from '../services/tour.service';

declare function resizeIFrames();

declare function triggerWindowScrollForBuilderListFilter();

@Component({
  selector: 'gt-builder-list',
  templateUrl: './builder-list.component.html',
  styleUrls: ['./builder-list.component.css']
})
export class BuilderListComponent implements OnInit, OnDestroy {

  // hostname: string;
  builders: Builder[];
  filteredBuilders: Builder[] = [];
  letterFilters: string[] = [];
  @Input() searchString = '';
  searchMatches = 0;
  showIFrame = false;
  private builderListSubscription: Subscription;

  // when called, will cause Observable returned by
  // inputChanges to emit
  emitInput: (event: KeyboardEvent) => void;

  constructor(public apiService: TourApiService, public tourService: TourService, private router: Router) { }

  ngOnInit() {
    if (this.apiService.builderList.length === 0) {
      this.apiService.fetchBuilderCommunityModelsList();
    } else {
      this.configureBuilderList();
    }

    // create an input delay for the search field
    this.inputChanges(1000).subscribe(
      input => this.searchBuilders(input)
    );

    this.apiService.tourLoaded.emit(false);
    // this.hostname = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port;
    this.tourService.tour = null;
    this.tourService.setDocumentTitleWithTour('Builder List');
    this.builderListSubscription = this.apiService.buildersLoaded.subscribe(
      (loaded: boolean) => {
        if (loaded) {
          this.configureBuilderList()
        }
      }
    );
  }

  configureBuilderList() {
    this.builders = this.apiService.builderList;
    this.filterBuildersByLetter(null);
    for (const builder of this.builders) {
      const letter = builder.name.substring(0, 1).toUpperCase();
      if (this.letterFilters.indexOf(letter) === -1) {
        this.letterFilters.push(letter);
      }
    }
  }

  // sets up emitInput to start sending values
  inputChanges(debounce: number): Observable<string> {
    return Observable.create(observer => {
      this.emitInput = (event: KeyboardEvent) => {
        observer.next((<HTMLInputElement>event.target).value)
      }
    }).distinctUntilChanged().debounceTime(debounce);
  }

  ngOnDestroy() {
    this.builderListSubscription.unsubscribe();
  }

  loadTourSkippingHistory(builder: string, model: string) {
    const routes = [builder, model];
    this.router.navigate(routes, {skipLocationChange: true});
  }

  filterBuildersByLetter(letter: string) {

    this.searchString = '';
    this.filteredBuilders = [];
    for (const builder of this.builders) {
      if (letter === null || builder.name.substring(0, 1).toUpperCase() === letter) {
        this.filteredBuilders.push(builder);
      }
    }
    triggerWindowScrollForBuilderListFilter()
  }

  searchBuilders(bouncedString: string) {
    this.searchString = bouncedString.toLowerCase();
    const buildersCopy = this.builders.slice();
    const searchResults: Builder[] = [];
    this.searchMatches = 0;

    for (const b of buildersCopy) {

      if (b.name.toLowerCase().indexOf(this.searchString) >= 0) {
        searchResults.push(b);

      } else {
        const matchingCommunities: Community[] = [];
        for (const c of b.communities) {
          // name, city or state matches
          if (this.containsSearchString(c.name)
              || (c.address.city && this.containsSearchString(c.address.city))
              || (c.address.state && this.containsSearchString(c.address.state))) {
            matchingCommunities.push(c);
          } else {
            const matchingModels: Model[] = [];
            for (const m of c.models) {
              if (this.containsSearchString(m.name)) {
                matchingModels.push(m);
              }
            }
            if (matchingModels.length > 0) {
                c.models = matchingModels;
                matchingCommunities.push(c);
            }
          }
        }
        if (matchingCommunities.length > 0) {
          b.communities = matchingCommunities;
          searchResults.push(b);
        }
      }
    }
    this.filteredBuilders = searchResults;
    // count the models
    for (const b of this.filteredBuilders) {
      for (const c of b.communities) {
        this.searchMatches += c.models.length;
      }
    }
    triggerWindowScrollForBuilderListFilter()
  }

  containsSearchString(field: string) {
    if (field.toLowerCase().indexOf(this.searchString) >= 0) {
      return true;
    }
    return false;
  }

  resetSearch() {
    this.searchString = '';
    this.filterBuildersByLetter(null);
  }

  toggleIFrame() {
    this.showIFrame = !this.showIFrame;
    if (this.showIFrame) {
      setTimeout(() => {
        resizeIFrames();
      }, 1000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/builder-list.component.ts